export enum ParentShipmentValidationType {
  PARENT,
  PSEG,
  MOVR
}
